import { RELATE_ANSWER_FIELDS } from "./RelateAnswerAction.const";
import { RelateAnswerPayload } from "./RelateAnswerAction.type";
import { arrEqualsAsPureSets } from "common/util/array/array_common";
import { removeAllWhitespace } from "common/util/text/string_common";
import { convertPinyinToEnVowels } from "common/util/convert/pronounce_convert";

export const relateAnswerFieldsGet = () => ({
  [RELATE_ANSWER_FIELDS.ANSWER_PRONOUNCE.name]: "",
  [RELATE_ANSWER_FIELDS.ANSWER_MEANING.name]: "",
});

export const checkAnswerCorrect = (
  characterAnswer: RelateAnswerPayload,
  answer: RelateAnswerPayload
): boolean => {
  console.log("checkAnswerCorrect");
  const check =
    checkPronounceCorrect(characterAnswer.pronounce, answer.pronounce) &&
    checkMeaningCorrect(characterAnswer.meaning, answer.meaning) &&
    checkContainCorrect(characterAnswer.contain, answer.contain);
  return check;
};

const checkPronounceCorrect = (
  charPronounce: string,
  pronounce: string
): boolean => {
  let charPronounceCheckFormat: string = removeAllWhitespace(charPronounce);
  let pronounceCheckFormat: string = removeAllWhitespace(pronounce);
  charPronounceCheckFormat = convertPinyinToEnVowels(
    charPronounceCheckFormat
  ).toLowerCase();
  pronounceCheckFormat =
    convertPinyinToEnVowels(pronounceCheckFormat).toLowerCase();
  return charPronounceCheckFormat === pronounceCheckFormat;
};

const checkMeaningCorrect = (charMeaning: string, meaning: string): boolean => {
  const charMeaningCheckFormat: string =
    removeAllWhitespace(charMeaning).toLowerCase();
  const meaningCheckFormat: string = removeAllWhitespace(meaning).toLowerCase();
  return charMeaningCheckFormat === meaningCheckFormat;
};

const checkContainCorrect = (
  charContain: string[],
  contain: string[]
): boolean => {
  return arrEqualsAsPureSets<string>(charContain, contain);
};
